import type { Messages } from '@/core/i18n/translator';

/**
 * Catalogues are split per namespace (ui.json, items.json, story.json…) so content and UI can be edited
 * independently. Vietnamese is bundled eagerly; English is fetched on demand.
 */
const viModules = import.meta.glob<Messages>('./vi/*.json', { eager: true, import: 'default' });
const enLoaders = import.meta.glob<Messages>('./en/*.json', { import: 'default' });

function merge(parts: readonly Messages[]): Messages {
  const out: Record<string, string> = {};
  for (const part of parts) {
    for (const [key, value] of Object.entries(part)) {
      if (key in out) throw new Error(`Duplicate i18n key "${key}"`);
      out[key] = value;
    }
  }
  return out;
}

export const viMessages: Messages = merge(Object.values(viModules));

export async function loadEnMessages(): Promise<Messages> {
  return merge(await Promise.all(Object.values(enLoaders).map((load) => load())));
}
